export default "__VITE_ASSET__f84f14dd__"